import { InstantDequipToolBehavior } from '../../canvas/tooling/InstantDequipToolBehavior';
import { ToolboxItem } from '../../canvas/tooling/ToolboxItem';
import { defineTool } from '../../canvas/tooling/ToolDefinition';
import { indexCardTool } from './IndexCardTool';
import { PaperWidget } from './PaperWidget';
import { roadmapCardTool } from './RoadmapCardTool';
import { stickyTool } from './StickyTool';
import { taskCardTool } from './TaskCardTool';

export const paperDequipTool = defineTool({
    id: 'paperDequipTool',
    label: '',
    category: 'core',
    behaviors: [
        InstantDequipToolBehavior,
    ]
});

export const paperToolboxItem = ToolboxItem({
    id: 'paperTools',
    label: 'Stickies & Cards',
    icon: 'deqo://icons/d2/sticky',
    ui: PaperWidget,
    weight: 1010,
    tools: [
        paperDequipTool,
        stickyTool,
        indexCardTool,
        taskCardTool,
        roadmapCardTool,
    ]
});
